import { Suspense } from 'react';

import type { IconProps } from './Icon.type';

const phosphorSprite = '/phosphor-icons-sprite.svg';

const pascalToKebabCase = (str: string): string => {
  return str
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
    .toLowerCase();
};

export function Icon({ name, className, size = 24, weight = 'regular', 'aria-hidden': ariaHidden }: IconProps) {
  if (!name) return null;

  const sizeStyle = typeof size === 'number' ? `${size}px` : size;

  const iconName = pascalToKebabCase(name);

  return (
    <Suspense fallback={null}>
      <svg
        className={className}
        width={sizeStyle}
        height={sizeStyle}
        aria-hidden={ariaHidden}
        style={{
          ...(weight === 'thin' && { strokeWidth: '1' }),
          ...(weight === 'light' && { strokeWidth: '1.5' }),
          ...(weight === 'regular' && { strokeWidth: '2' }),
          ...(weight === 'bold' && { strokeWidth: '3' }),
          ...(weight === 'fill' && { stroke: 'none' }),
          ...(weight === 'duotone' && { opacity: '0.7' }),
        }}
      >
        <title>{name}</title>
        <use href={`${phosphorSprite}#${iconName}`} />
      </svg>
    </Suspense>
  );
}
